<template>
  <el-container style="height: 100%;">
    <el-aside width="360px" style="background-color: #e4e6ecd6;position: relative;">
      <div class="headTitle">
        <div class="headItem" :class="{'is-active': index === activeIndex}" v-for="(item, index) in tabs" :key="index" @click="activeTabs(item)">{{item}}
        </div>
      </div>
      <div class="box" style="position:absolute;left:0;right:0;bottom:0;top:37px;overflow-y:auto">
        <div class="leftCon">
          <div class="formWrapper">
            <el-form
              ref="diagnoseForm" :model="diagnoseForm"
              size="mini"
              label-width="68px"
              label-position="left"
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="diagnoseForm.name" style="width: 236px;" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group
                  v-model="diagnoseForm.gender"
                  size="mini"
                  style="height:28px;"
                >
                  <el-radio-button label="男"></el-radio-button>
                  <el-radio-button label="女"></el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form
                       size="mini"
                       :inline="true"
                       style="width:100%;"
              >
                <span class="title" style="display: inline-block;font-size:14px;color: #606266;width:68px;height: 28px;line-height: 28px;">年龄</span>
                <el-form-item style="width:35%;">
                  <el-input v-model="diagnoseForm.age_start" placeholder="从" maxlength="3"
                  ></el-input>
                </el-form-item>
                <el-form-item style="width:35%;margin-right: 0;">
                  <el-input v-model="diagnoseForm.age_end" placeholder="到" maxlength="3"
                  ></el-input>
                </el-form-item>
              </el-form>
              <el-form-item label="诊断结果" prop="diagnosis">
              <el-autocomplete style="width: 236px;"
                class="popInput"
                v-model="diagnoseForm.diagnosis"
                :fetch-suggestions="queryDisease"
                placeholder="选择诊断结果（支持模糊搜索）"
                :trigger-on-focus="false"
                @select="selectedDisease"
                size="small"
              ></el-autocomplete>
              </el-form-item>
              <el-form-item label="病情描述" prop="curative_effect">
                <el-input v-model="diagnoseForm.curative_effect" style="width: 236px;" placeholder="支持模糊搜索病情信息"></el-input>
              </el-form-item>
              <el-form
                size="mini"
                :inline="true"
                style="width:100%;"
              >
                <span class="title" style="display: inline-block;font-size:14px;color: #606266;width:68px;height: 28px;line-height: 28px;">入院日期</span>
                <el-form-item style="width:35%;">
                  <el-date-picker
                    v-model="diagnoseForm.inpat_date_start"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="从"
                   >
                  </el-date-picker>
                
                </el-form-item>
                <el-form-item style="width:35% ;margin-right: 0;">
                  <el-date-picker
                    v-model="diagnoseForm.inpat_date_end"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="到"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <el-form
                size="mini"
                :inline="true"
                style="width:100%;"
              >
                <span class="title" style="display: inline-block;font-size:14px;color: #606266;width:68px;height: 28px;line-height: 28px;">出院日期</span>
                <el-form-item style="width:35%">
                  <el-date-picker
                    v-model="diagnoseForm.outpat_date_start"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="从"
                  >
                  </el-date-picker>  
                </el-form-item>
                <el-form-item style="width:35% ;margin-right: 0;">
                  <el-date-picker
                    v-model="diagnoseForm.outpat_date_end"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="到"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>

              <el-form-item label="主诊医师" prop="main_diagnosis_doctor">
                  <el-autocomplete style="width: 236px;"
                    class="popInput"
                    v-model="diagnoseForm.main_diagnosis_doctor"
                    :fetch-suggestions="mainSuggesion"
                    placeholder="请输入内容"
                  ></el-autocomplete>
              </el-form-item>
              <el-form-item label="副主诊医师" prop="vice_diagnosis_doctor">
                  <el-autocomplete style="width: 236px;"
                    class="popInput"
                    v-model="diagnoseForm.vice_diagnosis_doctor"
                    :fetch-suggestions="viceSuggesion"
                    placeholder="请输入内容"
                  ></el-autocomplete>
              </el-form-item>

              <el-form-item label="备注" prop="remarks">
                <el-input v-model="diagnoseForm.remarks" style="width: 236px;" placeholder="支持模糊搜索备注信息"></el-input>
              </el-form-item>

              <el-form-item style="margin-bottom: 31px;">
              <div class="moreWrapper" v-show="showMore" style="width: 94%">
                <!--<div class="moreBtn iconfont" @click="showMoreEvent">&#xe7fe;</div>-->
                <div class="show-more-text"  @click="showMoreEvent">更多</div>
                <div class="iconfont show-more-btn" @click="showMoreEvent">&#xe7fe;</div>
              </div>
              </el-form-item>

              <el-form-item label="中/西医治疗" v-show="!showMore" prop="treat_method">
                <el-select  style="width: 236px;"
                  placeholder="请选择"
                  v-model="diagnoseForm.treat_method"
                  class="popInput"
                >
                  <el-option
                    v-for="item in treatMethodOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-show="!showMore" label="创建时间">
                <el-date-picker
                  style="width: 236px"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item v-show="!showMore" label="民族">
                <el-select
                  v-model="diagnoseForm.race"
                  placeholder="民族"
                  size="mini"
                  style="width:80px;"
                >
                  <el-option
                    v-for="item in races"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="!showMore" label="肤色" prop="name">
                <el-select
                  v-model="diagnoseForm.skin_color"
                  placeholder="选择肤色"
                  size="mini"
                  style="width:236px"
                >
                  <el-option
                    v-for="item in skinOps"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="!showMore" label="电话" prop="phone">
                <el-input v-model="diagnoseForm.phone" style="width: 236px;"
                  placeholder="请输入完整的电话号" maxlength="11" @input="stipulateNumber('phone')"></el-input>
              </el-form-item>
              <el-form-item v-show="!showMore" label="地址" prop="address">
                <el-input v-model="diagnoseForm.address" style="width: 236px;"
                  placeholder="请输入地址"></el-input>
              </el-form-item>

              <el-form-item v-show="!showMore" label="身份证" prop="idCardNumber">
                <el-input
                  v-model="diagnoseForm.id_card_number"
                  type
                  placeholder="请输入完整的身份证号"
                  style="width:236px;"
                  maxlength="18"
                  @input="stipulateNumber('id_card_number')"
                ></el-input>
              </el-form-item>
              <!--显示更多时候所显示的内容-->
              <el-form-item style="margin-bottom: 31px;" v-show="!showMore">
              <div class="moreWrapper" >
                <!--<div class="moreBtn iconfont" @click="closeMoreEvent">&#xe7d3;</div>-->
                <div class="show-more-text"  @click="closeMoreEvent">收起</div>
                <div class="iconfont show-more-btn" @click="closeMoreEvent">&#xe7d3;</div>
              </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-aside>
    <el-container>
      <div class="right-content-wrap">
        <div class="right-content-wrap-main">
          <el-container style="height: 96%;padding: 0px;">
            <el-main style="padding: 0;">
              <div class="rightCon">
                <div class="filterCon">
                  <div class="filterItem" v-for="(item, key) in diagnoseSelect" :key="key" v-show="item.val">
                    <div>{{item.key}}：{{item.val}}</div>
                    <div class="close-btn iconfont" @click="closeFilter(key)">&#xe634;</div>
                  </div>
                </div>
                <div class="filter-count"   v-show="activeIndex === 0&&differentContent.diagExport">
                  <div class="download-btn-wrap" v-acl="['export_hostory']">
                    <div class="download-btn" @click="downloadAllInfo">导出全部</div>
                    <div class="download-btn" @click="downloadFolderInfo">导出</div>
                  </div>
                </div>
                <div class="filter-count"  v-show="activeIndex === 1">
                  <div class="download-btn-wrap" v-acl="['export_hostory']">
                    <div class="download-btn" @click="downloadAll">导出全部</div>
                    <div class="download-btn" @click="downloadSelected">导出</div>
                  </div>
                </div>
                <!--存放诊断记录的容器-->
                <div class="diagnoses-con" v-show="activeIndex === 0">
                  <div class="moreItem">
                    
                    <div v-for="(innerItem, index) in moreResultArr" :key="index" class="check-box"
                         @click.stop="getInfo(innerItem.patient_id, innerItem.id)"
                         v-if="innerItem.image_hospitalization">                    
                      <!--   <div class="img-box">
                           <img :src="imageSrcPrefixThumbnails+innerItem.images[0].path" alt="" class="check-img"
                                v-if="innerItem.images[0]" @load="imgOnload">
                         </div>-->
                      <div class="img-box">
                        <img :src="imageSrcPrefixThumbnails+innerItem.image_hospitalization[0].path" alt="" class="check-img"
                             v-if="innerItem.image_hospitalization[0]" />
                      </div>
                      <div class="check-info">
                        <p style="display: flex;justify-content: space-between;">
                          <span style="flex: 1;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                            <span>患者: </span>  <span>{{innerItem.patient.name}}/{{innerItem.patient.gender}}/{{innerItem.patient.age>0?innerItem.patient.age:''}} </span>
                          </span>                        
                        </p>
                        <!-- <p class="ellipsis">检查类型: <span v-if="innerItem.image_hospitalization.length">{{innerItem.image_hospitalization[0].type |
                            filtersType}}</span>
                        </p> -->
                        <p class="ellipsis"  style="text-overflow: ellipsis;">
                          病程及诊断:  
                          <span>{{innerItem.disease_course?innerItem.disease_course:'-'}};</span>                            
                          <!-- <span>{{innerItem.diagnosis | formatConclusion}}</span>   -->
                          <span>{{innerItem.diagnosis?innerItem.diagnosis:'-'}}</span>                              
                        </p>     
                        <p class="ellipsis" style="text-overflow: ellipsis;">
                          病情:
                          <span >{{innerItem.curative_effect}}</span>
                        </p>
                        <!-- <p class="ellipsis" style="text-overflow: ellipsis;">
                          入院: 
                          <span>{{innerItem.inpat_date | filtersMoment}}</span>
                        </p> -->
                        <p class="ellipsis" style="text-overflow: ellipsis;">
                          记录时间: 
                          <span>{{innerItem.update_time}}</span>
                        </p>
                        <!-- <p style="display: flex;">中/西医治疗: <span class="ellipsisSpan ellipsis">{{innerItem.treat_method}}</span></p> -->
                        <div style="display: flex;align-items: flex-end;justify-content: space-between;">
                          <p class="ellipsisP">备注: <span class="ellipsis ellipsisSpan" style="text-overflow: ellipsis;" >{{innerItem.remarks}}</span></p>
                          <div
                            class="iconfont modify-btn"
                            v-acl="['diagnoses_image']"
                            style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold;cursor: pointer"
                            title="编辑诊断"
                            @click.stop="modifyDiagnosis(innerItem)"
                            v-if="innerItem.isedit === 1"
                          >&#xe630e;</div>
                          <div
                            class="iconfont"
                            v-acl="['diagnoses_image']"
                            style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                            title="不可编辑"
                            v-else
                            @click.stop
                          >&#xe630e;</div>
                        </div>
                      </div>
                      <span @click.stop="selectedM(index)" class="iconfontRFather">
                        <span
                          v-if="innerItem.select"
                          id="iconfontR"
                          class="iconfont"
                        >&#xe642;</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="diagnoses-con2" v-show="activeIndex === 1">
                  <div class="content">
                    <div class="moreItem">
                      <div class="images-item" v-for="(item, index) in moreImageArr" :key="index"
                           @click.stop="showPic(item)">
                        <img ref="image" class="image"
                             :src="imageSrcPrefixThumbnails+item.path" alt="">
                        <div class="download-btn-box"  v-acl="['export_hostory']">
                          <div class="download-btn botton iconfont" @click.stop="downloadImage(item.path)">&#xe7a3;
                          </div>
                          <div class="selected-btn botton" @click.stop="selected(index)">
                            <span class="iconfont" v-show="item.select">&#xe642;</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-main>
          </el-container>
          <div class="pagination" >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageNumber"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </div>
     
      </div>
    </el-container>
    <el-dialog
      :visible.sync="showLargeImage"
      center
      custom-class="similarDialog showBigImage_dialog_1"
      modal
      top="0"
      :fullscreen="true"
    >
      <div class="bigImage">
        <Lookimage :largeImgage="largeImgage"></Lookimage>
      </div>
    </el-dialog>
    <InHospitalDialog
      :openHospitalId="openHospitalId"
      :isShowInHospital="isShowInHospital"
      :toDialoPatientsData="toDialoPatientsData"
      @setInHpspitalStatus="setInHpspitalStatus()"
      @refreshHandler1="refreshHandler1"
    ></InHospitalDialog>
  </el-container>


</template>
<script>
  
  // 图片下载
  const downloadIamge = (src, name) => {
    const image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous');
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0, image.width, image.height);
      const url = canvas.toDataURL('image/jpeg',1.0);
      // 生成一个a元素
      const a = document.createElement('a');
      // 创建一个单击事件
      const event = new MouseEvent('click');
      // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
      a.download = name || '图片';
      // 将生成的URL设置为a.href属性
      a.href = url;
      // 触发a的单击事件
      a.dispatchEvent(event)
    };
    image.src = src;
  };
  // import axios from 'axios';
  // import api from '../api';
  import csrftoken from '../getToken';
  import InHospital from "../utils/inHospital.js";
  import moment from '../../node_modules/moment/src/moment.js';
  import raceJson from "../race.js";
  import gql from 'graphql-tag';
  import PatientDiagnoseRecord from './PatientDiagnoseRecord.vue';
  import axios from 'axios';
  import api from '../api';
  import Lookimage from './LookBigImage.vue';
  import popMixins from "../utils/popMixins.js";
  import controllerDuration from "../utils/controllerDuration.js";
  import DiagnoseRecord from "./DiagnoseRecord";
  let template = {};
  let that;
  
  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    // differentContent.errorCon = '请先进行智能搜图!!';
    differentContent.diagExport = true;
  } else {
    differentContent.diagExport = false;
    
  }
  export default {
    name: 'InHospitalManager',
    mixins:[popMixins, controllerDuration,InHospital],
    data() {
      return {
        
        differentContent,
        imageResult: {
          imageSrc: '',
        },
        dialogImage: false,
        // // 详情切换
        // showDetails: false,
        // 是否显示影像大图
        isShowPic: true,
        // 详情页数据
        patientinfo: {},
        diagnoseinfo: [],
        // 请求图片前缀
        imageSrcPrefixThumbnails: api.hospitalization_imagesThumbnails,
        imageSrcPrefix: api.hospitalization_images,
        // 诊断记录的列表
        moreResultArr: [],
        moreImageArr: [],
        // tabs
        tabs: ["就诊记录", "影像"],
        // show more
        showMore: true,
        skinOps: raceJson.skinOpn,
        position: raceJson.position.noDistinguish,
        position2: [],
        knowledge: [],
        knowledge2: [],
        races: raceJson.raceObj,
        applyUnitData: raceJson.applyUint,
        // 右侧筛选显示数据
        diagnoseSelect: {},
        diagnoseSelectTransfer: {
          image_type_flag: '检查类型',
          applicant: '申请医生',
          applicant_unit: '申请单位',
          review_doctor: '审核医生',
          unit: '检查单位',
          id_in_hospital: '检查编号',
          initial_conclusion: '临床诊断',
          name: '姓名',
          gender: '性别',
          skin_color: '肤色',
          phone: '电话',
          address: '地址',
          remarks: '备注',
          position: '检查部位',
          id_card_number: '身份证',
          native_place: '籍贯',
          country: '国别',
          profession: '职业',
          email: '电子邮件',
          complaint: '主诉',
          lab: '实验室',
          race: '民族',
          diagnosis:'诊断',
          treat_no:'治疗编号',
          treat_method:'中/西医治疗',
          curative_effect:'病情',
          main_diagnosis_doctor:'主诊医师',
          vice_diagnosis_doctor:'辅主诊医师'
        },
        imageTypeFilter: [],
        treatMethodOptions: [
          { label: "中西医治疗", id: 0, value: "中西医治疗" },
          { label: "中医治疗", id: 1, value: "中医治疗" },
          { label: "西医治疗", id: 2, value: "西医治疗" }
        ],
        curativeEffectOptions: [
          { label: "痊愈", id: 0, value: "痊愈" },
          { label: "好转", id: 1, value: "好转" },
          { label: "无效", id: 2, value: "无效" }
        ],
        mainDoctorList: [],
        viceDoctorList: [],
        inpatDoctorList:[],
        allDisease: [],
        diagnoseForm: {
          time_start: '',
          time_end: '',
          inpat_date_start: '',
          inpat_date_end: '',
          outpat_date_start: '',
          outpat_date_end: '',
        },
        dateRange: "",
        position_overview: '',
        position_detail: '',
        taggedFilter: '',
        age_start: '',
        age_end: '',
        imgDiagnose_main: '',
        imgDiagnose_sub: '',
        // 大体位置的索引
        overviewIndex: 0,
        imgForm: {},
        activeIndex: 0,
        images: [],
        showInfo: false,
        patientId: '',
        diagnosisId: '',
        isTrigger:false,
        date: '',
        result: [],
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        },
        allNum: 15,
        sId: '',
        sName: '',
        sAge: '',
        startAge: '',
        endAge: '',
        sGender: '',
        sDate: '',
        options4: [
          {
            value: '男',
            label: '男'
          }, {
            value: '女',
            label: '女'
          },
        ],
        imagesType: ['大体图/伍德灯', '浸润皮肤镜图', '偏振光皮肤镜图', '皮肤CT', '皮肤B超', '皮肤病理'],
        timer: '',
        // 分页相关参数
        
        // 显示大图参数
        picDetails: {
          position: '',
          type: '',
          time: '',
          size: '',
        },
        imgSwitch: false,
        // graphql请求的参数
        requestParams1:
          `count
          data{
            id
            patient_id
            isedit
            is_critical
            medical_record_num
            inpat_date
            outpat_date
            inpat_days_num
            diagnosis
            curative_effect
            disease_course
            remarks
            treat_method
            main_diagnosis_doctor
            vice_diagnosis_doctor
            inpat_doctor
            inpat_img
            outpat_img
            created_time
            update_time
            image_hospitalization{
              id
              type
              path
              hospitalization_id
              created_time
            }
            patient{
              id
              name
              gender
              birthday
              age
              id_in_hospital
              race
              skin_color
              skin_type
              phone
              address
              id_card_number
              native_place
              country
              profession
              email
              created_time
              update_time
              last_diagnosis_text
              last_main_suit
              last_past_history
              last_id_inhospital
              account_balance
              medical_record_num
            }
         }
          `,
        pageTotal:0,
        pageNumber:1,
        pageSize:20,
        // 查看大图地址
        largeImgage: '',
        showLargeImage: false,
        knowledgeDic: {},
        initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
        queryParam: '',
        isDownloadFolder: false,
        selectItemsId:[]
      };
    },
    watch: {
      'position_overview'(newVal) {
        this.position2 = this.position[newVal];
        this.diagnoseForm.position = newVal;
      },
      'position_detail'(newVal) {
        if (newVal) {
          this.diagnoseForm.position = this.position_overview + '-' + newVal;
        } else {
          this.diagnoseForm.position = this.position_overview;
        }
      },
    /*  'age_start'(newVal) {
        if (this.age_end !== '') {
          if (newVal) {
            const ageEndS = this.age_end;
            const ageEnd = Number(ageEndS);
            const val = Number(newVal);
            if (val <= ageEnd) {
              this.diagnoseForm.age_start = newVal;
              this.diagnoseForm.age_end = ageEndS;
            } else {
              this.diagnoseForm.age_start = ageEndS;
              this.diagnoseForm.age_end = newVal;
            }
          } else {
            this.diagnoseForm.age_start = this.age_end;
            this.diagnoseForm.age_end = newVal;
          }
        } else {
          this.diagnoseForm.age_start = newVal;
          this.diagnoseForm.age_end = '';
        }
      },*/
      'age_end'(newVal) {
        if (this.age_start !== '') {
          if (newVal) {
            const ageStartS = this.age_start;
            const ageStart = Number(ageStartS);
            const val = Number(newVal);
            if (ageStart <= val) {
              this.diagnoseForm.age_start = ageStartS;
              this.diagnoseForm.age_end = newVal;
            } else {
              this.diagnoseForm.age_start = newVal;
              this.diagnoseForm.age_end = ageStartS;
            }
          } else {
            this.diagnoseForm.age_start = this.age_start;
            this.diagnoseForm.age_end = newVal;
          }
        } else {
          this.diagnoseForm.age_start = newVal;
          this.diagnoseForm.age_end = '';
        }
      },
      'diagnoseForm.inpat_date_start'(newVal) {
        const inpat_date_end = this.diagnoseForm.inpat_date_end;
        if (inpat_date_end) {
          this.diagnoseSelect.inpat_date = {
            key: '入院日期',
            val: moment(newVal).format("YYYY-MM-DD") + '至' +moment(inpat_date_end).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseSelect.inpat_date = {
            key: '入院日期',
            val: moment(newVal).format("YYYY-MM-DD")
          };
        }
      },
      'diagnoseForm.inpat_date_end'(newVal) {
        const inpat_date_start = this.diagnoseForm.inpat_date_start;
        if (newVal) {
          this.diagnoseSelect.inpat_date = {
            key: '入院日期',
            val: moment((inpat_date_start ? inpat_date_start : '')).format("YYYY-MM-DD") + '至' +moment(newVal).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseSelect.inpat_date = {
            key: '入院日期',
            val: moment(inpat_date_start).format("YYYY-MM-DD")
          }
        }
      },
      'diagnoseForm.outpat_date_start'(newVal) {
        const outpat_date_start = this.diagnoseForm.outpat_date_start;
        if (outpat_date_start) {
          this.diagnoseSelect.outpat_date = {
            key: '出院日期',
            val: moment(newVal).format("YYYY-MM-DD") + '至' +moment(outpat_date_start).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseSelect.outpat_date = {
            key: '出院日期',
            val: moment(newVal).format("YYYY-MM-DD")
          };
        }
      },
      'diagnoseForm.outpat_date_end'(newVal) {
        const outpat_date_start = this.diagnoseForm.outpat_date_start;
        if (newVal) {
          this.diagnoseSelect.outpat_date = {
            key: '出院日期',
            val: moment((outpat_date_start ? outpat_date_start : '')).format("YYYY-MM-DD") + '至' +moment(newVal).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseSelect.outpat_date = {
            key: '出院日期',
            val: moment(outpat_date_start).format("YYYY-MM-DD")
          }
        }
      },
      'diagnoseForm.age_start'(newVal) {
        const age_end = this.diagnoseForm.age_end;
        if (age_end) {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: newVal + '-' + age_end,
          };
        } else {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: newVal,
          };
        }
      },
      'diagnoseForm.age_end'(newVal) {
        const age_start = this.diagnoseForm.age_start;
        if (newVal) {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: (age_start ? age_start : '') + '-' + newVal,
          };
        } else {
          this.diagnoseSelect.age = {
            key: '年龄',
            val: age_start,
          }
        }
      },
      'dateRange'(newVal) {
        if (newVal) {
          this.diagnoseForm.time_start = newVal[0];
          this.diagnoseForm.time_end = newVal[1];
          this.diagnoseSelect.time = {
            key: '创建时间',
            val: moment(newVal[0]).format("YYYY-MM-DD") + '至' +moment(newVal[1]).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseForm.time_end = '';
          this.diagnoseForm.time_start = '';
          this.diagnoseSelect.time = '';
        }
      },
      'imageTypeFilter'(newVal) {
        let count = 0;
        newVal.forEach(item => {
          count += Number(item);
        });
        count = count === 0 ? '' : count;
        this.diagnoseForm.image_type_flag = count;
        // 右侧筛选tab显示
        let value = '';
        newVal.forEach(item => {
          const type = this.imagesType;
          let index = 10;
          switch (item) {
            case "1":
              index = 0;
              break;
            case "2":
              index = 1;
              break;
            case "4":
              index = 2;
              break;
            case "8":
              index = 3;
              break;
            case "16":
              index = 4;
              break;
            case "32":
              index = 5;
              break;
          }
          value += type[index] + ' ';
        });
        this.diagnoseSelect.type = {
          key: '检查类型',
          val: value,
        };
      },
      'taggedFilter'(newVal) {
        if (newVal === '是') {
          this.diagnoseForm.tagged = 1;
          this.diagnoseSelect.tagged = {
            key: '收藏',
            val: newVal,
          };
        } else if (newVal === '否') {
          this.diagnoseForm.tagged = 0;
          this.diagnoseSelect.tagged = {
            key: '收藏',
            val: newVal,
          };
        } else if (newVal === '') {
          this.diagnoseForm.tagged = '';
        }
      },
      'imgDiagnose_main'(newVal) {
        let val = newVal;
        if (newVal !== '') {
          this.diagnoseForm.doctor_conclusion = String(++val);
          this.knowledge2 = this.knowledge[--val].children;
          // 右侧筛选卡显示
          this.diagnoseSelect.doctor_conclusion = {
            key: '影像诊断',
            val: this.knowledge[newVal].name,
          }
        } else {
          this.diagnoseForm.doctor_conclusion = '';
          this.knowledge2 = [];
          // 右侧筛选卡显示
          this.diagnoseSelect.doctor_conclusion = {
            key: '影像诊断',
            val: '',
          }
        }
        this.imgDiagnose_sub = '';
      },
      'imgDiagnose_sub'(newVal) {
        if (newVal !== '') {
          this.diagnoseForm.doctor_conclusion = newVal;
          // 右侧筛选卡显示
          this.diagnoseSelect.doctor_conclusion = {
            key: '影像诊断',
            val: this.knowledge[this.imgDiagnose_main].name + ' - ' +
              this.knowledge[this.imgDiagnose_main].children[newVal.split('-')[1] * 1 - 1].name,
          }
        } else {
          let val = this.imgDiagnose_main;
          if (val !== '') {
            this.diagnoseForm.doctor_conclusion = String(++val);
            // 右侧筛选卡显示
            this.diagnoseSelect.doctor_conclusion = {
              key: '影像诊断',
              val: this.knowledge[this.imgDiagnose_main].name,
            }
          } else {
            this.diagnoseForm.doctor_conclusion = '';
            // 右侧筛选卡显示
            this.diagnoseSelect.doctor_conclusion = {
              key: '影像诊断',
              val: '',
            }
          }
        }
      },
      
      // 监听筛选的数据进行请求
      'diagnoseForm': {
        async handler(newval) {
          clearTimeout(this.timer);
          const diagnose = newval;
          const newDiagnoseForm = this.forInDiagnoseForm(diagnose);
          let newDiagnoseSelect = this.diagnoseSelect;
          const transfer = this.diagnoseSelectTransfer;
          for (let key in diagnose) {
            if (diagnose.hasOwnProperty(key)) {
              let val = diagnose[key];
              // 右侧选项卡显示
              if (!(key === 'age_start' || key === 'age_end'  || key === 'time_start'
                || key === 'inpat_date_start'|| key === 'inpat_date_end'|| key === 'outpat_date_start'|| key === 'outpat_date_end'
                || key === 'time_end' || key ===
                'image_type_flag' || key === 'tagged' || key === 'doctor_conclusion')) {
                newDiagnoseSelect[key] = {
                  key: transfer[key],
                  val,
                };
              }
            }
          }
          // 调用请求数据方法
  
          this.pageNumber = 1
          this.init()
          this.queryParam = newDiagnoseForm;
        },
        deep: true
      },
    },
    async mounted() {
      this.getLocalList(this.mainDoctorList, "mainDoctorListtest");
      this.getLocalList(this.viceDoctorList, "viceDoctorListtest");
      this.getLocalList(this.inpatDoctorList, "inpatDoctorListtest");
      await this.queryMyTemplate();
      const response = await axios.request({
        method: 'get',
        url: api.knowledge,
      });
      const res = await axios.request({
        method: 'get',
        url: api.knowledgeDic,
      });
      this.knowledgeDic  = res.data;
      this.knowledge = response.data.children;
      if (this.$store.state.filterState.saveState) {
        // 取得vuex中保存的状态和数据
        const data = this.$store.state.filterState.data;
        const diagnoseForm = this.$store.state.filterState.diagnoseForm;
        const diagnoseSelect = this.$store.state.filterState.diagnoseSelect;
        this.diagnoseSelect = diagnoseSelect;
        this.diagnoseForm = diagnoseForm;
        this.age_start = data.age_start;
        this.age_end = data.age_end;
        this.dateRange = data.dateRange;
        this.position_overview = data.position_overview;
        this.position_detail = data.position_detail;
        this.imageTypeFilter = data.imageTypeFilter;
        this.taggedFilter = data.taggedFilter;
        this.imgDiagnose_main = data.imgDiagnose_main;
        this.$nextTick(() => {
          this.imgDiagnose_sub = data.imgDiagnose_sub;
        });
        this.$store.commit('clearSaveState')
      } else {
        this.init();
      }
    },
    methods: {
      getLocalList(thisData, localName) {
        let DoctorList = localStorage.getItem(localName);
        if (DoctorList) {
          let data = JSON.parse(DoctorList);
          for (const item of data) {
            thisData.push({ value: item });
          }
        }
      },
      refreshHandler1(){
        this.init();
      },
      async init(){
        const newDiagnoseForm = this.forInDiagnoseForm(this.diagnoseForm);
        if (this.activeIndex === 0){
         /* const response = await this.$apollo.query({
            query: gql`{
                    diagnoses(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                        ${this.requestParams}
                    }
                }`,
            fetchPolicy: 'no-cache',
          });*/
          // console.log("In inhospitalManager, init, diagnosesHospitalPaging, query paras:",this.diagnoseForm);
          const response = await this.$apollo.query({
            query: gql`{
                    diagnosesHospitalPaging(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                        ${this.requestParams1}
                    }
                }`,
            fetchPolicy: 'no-cache',
          });
        
          this.moreResultArr = response.data.diagnosesHospitalPaging.data;
          for(let tmpItem of this.moreResultArr){
            tmpItem.update_time = moment(tmpItem.update_time).format("YYYY-MM-DD");
            tmpItem.created_time = moment(tmpItem.created_time).format("YYYY-MM-DD");
            tmpItem.inpat_date = moment(tmpItem.inpat_date).format("YYYY-MM-DD");
          }
     
           /*this.handleIsPrint(response.data.diagnosesHospitalPaging.data);*/
          this.pageTotal = response.data.diagnosesHospitalPaging.count
        } else if(this.activeIndex === 1){
          this.pageSize = 35
          const res = await new Promise((resolve) => {
            const response = this.$apollo.query({
              query: gql`{
                  imagesHospitalPaging(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                      count
                      data{
                      id
                      path
                      hospitalization_id
                      created_time
                      type}
                  }
              }`,
              fetchPolicy: 'no-cache',
            });
            resolve(response);
          })
        
          this.moreImageArr = res.data.imagesHospitalPaging.data;
          this.pageTotal = res.data.imagesHospitalPaging.count;
        }
        
      },
      handleCurrentChange(val){
        this.pageNumber = val
        this.init();
      },
      // 是否显示编辑按钮
      isShowModifyDiagnosisBtn(date) {
        return !(moment().diff(date) >= this.countTimeModifyDiagnosisBtn);
      },
      // 编辑诊断
      async modifyDiagnosis(item) {
          this.getInHospital(item.id, item.patient);
      },
      // 导出文件夹
      async downloadFolderInfo() {
        if (!this.isDownloadFolder) {
          if (this.selectItemsId.length !== 0){
            this.isDownloadFolder = true;
            try {
              const res = await this.$apollo.query({
                query: gql`query(
              $diagnosis_ids: [Int]
            ){
                diagnosesHospitalExport(diagnosis_ids:$diagnosis_ids)
              }`,
                variables:{
                  diagnosis_ids:this.selectItemsId
                },
                fetchPolicy: "no-cache",
              });
              const a = document.createElement('a'); // 创建a标签
              a.setAttribute('href', api.server + res.data.diagnosesHospitalExport);// href链接
              a.click();
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
            this.isDownloadFolder = false;
          } else {
            this.$message('没有选中信息');
          }
     
        }
      },
      // 导出文件夹
      async downloadFolder() {
        if (!this.isDownloadFolder) {
          this.isDownloadFolder = true;
          try {
            const res = await this.$apollo.query({
              query: gql`{
                diagnosesExport(${this.queryParam}page_number:${this.pageNumber}, page_size:${this.pageSize})
              }`,
              fetchPolicy: "no-cache",
            });
            const a = document.createElement('a'); // 创建a标签
            a.setAttribute('href', api.server + res.data.diagnosesExport);// href链接
            a.click();
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
          this.isDownloadFolder = false;
        }
      },
      // 获取医生自定义模板
      async queryMyTemplate() {
        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          return;
        }
        const msg =  await axios.request({
          method: 'get',
          url: api.template + path,
        });
        template = msg.data;
      },
      // 处理是否打印过报告
      handleIsPrint(data) {
        for (const item of data) {
          const index = item.images.findIndex(image => image.print_time !== this.initialTime);
          item.isPrintReport = !(index > -1);
        }
        return data;
      },
      // 关闭查看大图dialog
      closeImageDetails(val) {
        this.dialogImage = val;
      },
      imgOnload(e) {
        const tag = e.target;
        if (tag.width / tag.height >= 1) {
          e.srcElement.style.height = '78px';
          e.srcElement.style.width = '84px';
          const s = (tag.width - 84) / 2;
          
        } else {
          e.srcElement.style.width = '78px%';
          e.srcElement.style.height = '84px';
          const s = (tag.height - 84) / 2;
          /*  e.srcElement.style.marginLeft = 0;*/
          
        }
      },
      
      
      // 显示更多按钮
      showMoreEvent() {
        this.showMore = false;
      },
      closeMoreEvent() {
        this.showMore = true;
      },
      
      async activeTabs(params) {
        switch (params) {
          case "就诊记录":
            this.activeIndex = 0;
            break;
          case "影像":
            this.activeIndex = 1;
            break;
          
        }
        // 点击请求数据
        // const diagnose = this.diagnoseForm;
        
        // 调用请求数据方法
        this.pageNumber = 1
        this.init();
      },
      choosedOverview(data) {
        this.position_detail = '';
      },
      closeInfo() {
        this.showInfo = false;
      },
      // 显示详情页
      async getInfo(id, id2) {
        try {
          // const params = {
          //   patientId: id,
          //   selectId: id2,
          //   diagnosisType: '影像',
          // };
          // if (window.sessionStorage) {
          //   this.$router.push({name: 'details'});
          //   window.sessionStorage.setItem('diagnosisParams', JSON.stringify(params));
          // } else {
          //   this.$router.push({
          //     name: 'details',
          //     params
          //   });
          // }

          //采用全局变量缓存参数
          this.$store.commit("setPatientDiagnosisRecordPara", {
              patientId: id,
              selectId: id2,
              diagnosisType: '影像'
          });
          this.$router.push({ name: "details" });

        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
        // 将筛选的状态保存到vuex中
        const filterState = {
          data: {
            age_start: this.age_start,
            age_end: this.age_end,
            dateRange: this.dateRange,
            position_overview: this.position_overview,
            position_detail: this.position_detail,
            imageTypeFilter: this.imageTypeFilter,
            taggedFilter: this.taggedFilter,
            imgDiagnose_main: this.imgDiagnose_main,
            imgDiagnose_sub: this.imgDiagnose_sub,
          },
          diagnoseSelect: this.diagnoseSelect,
          diagnoseForm: this.diagnoseForm,
          saveState: true,
        };
        this.$store.commit('saveFilterState', filterState);
      },
      // 单个下载
      downloadImage(path) {
        const imageName = path.split('.')[0];
        const src = this.imageSrcPrefix + path;
        downloadIamge(src, imageName);
      },
      // 导出
      downloadSelected() {
        const selectedArr = this.moreImageArr.filter(item => {
          return item.select;
        });
        if (selectedArr.length !== 0) {
          selectedArr.forEach(item => {
            const imageName = item.path.split('.')[0];
            const src = this.imageSrcPrefix + item.path;
            downloadIamge(src, imageName);
          })
        } else {
          this.$message('没有选中图片');
        }
        this.moreImageArr.forEach(item => {
          item.select = false;
        });
        this.$forceUpdate();
      },
      downloadSelected() {
        const selectedArr = this.moreImageArr.filter(item => {
          return item.select;
        });
        if (selectedArr.length !== 0) {
          selectedArr.forEach(item => {
            const imageName = item.path.split('.')[0];
            const src = this.imageSrcPrefix + item.path;
            downloadIamge(src, imageName);
          })
        } else {
          this.$message('没有选中图片');
        }
        this.moreImageArr.forEach(item => {
          item.select = false;
        });
        this.$forceUpdate();
      },
      // 导出全部
     async downloadAllInfo() {
        if (!this.isDownloadFolder) {
            this.isDownloadFolder = true;
            try {
              const res = await this.$apollo.query({
                query: gql`{
                diagnosesHospitalExport(${this.queryParam}page_number:${this.pageNumber}, page_size:${this.pageSize})
              }`,
                fetchPolicy: "no-cache",
              });
              const a = document.createElement('a'); // 创建a标签
              a.setAttribute('href', api.server + res.data.diagnosesHospitalExport);// href链接
              a.click();
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
            this.isDownloadFolder = false;
    
        }
      },
      downloadAll() {
        const all = this.moreImageArr;
        if (all.length !== 0) {
          all.forEach(item => {
            const imageName = item.path.split('.')[0];
            const src = this.imageSrcPrefix + item.path;
            downloadIamge(src, imageName);
          })
        } else {
          this.$message('没有可下载内容');
        }
      },
      // 点击取消筛选项
      closeFilter(key) {
        if (key === 'age'){
          this.diagnoseForm.age_start = ''
          this.diagnoseForm.age_end = ''
        }
        
        if (key === 'inpat_date'){
          this.diagnoseForm.inpat_date_start = ''
          this.diagnoseForm.inpat_date_end = ''
        }
        if (key === 'outpat_date'){
          this.diagnoseForm.outpat_date_start = ''
          this.diagnoseForm.outpat_date_end = ''
        }
        if (key === 'time'){
          this.dateRange = ''
        }  else {
          this.diagnoseForm[key] = '';
        }
        
      },
      // 显示影像大图
      showPic(data) {
        // 新查看大图方式传入地址
        this.largeImgage = `${this.imageSrcPrefix}${data.path}`;
        this.showLargeImage = true;
        
        
        // 旧查看大图方式传入地址
        // this.$refs.img.src = `${this.imageSrcPrefix}${data.path}`;
        // this.isShowPic = true;
        
        // dialog相关操作
        this.imageResult.imageSrc = `${this.imageSrcPrefix}${data.path}`;
        this.dialogImage = true;
        
        // 检查部位
        this.picDetails.position = data.position_detail;
        // 检查类型
        const type = this.imagesType;
        let index = 10;
        switch (data.type) {
          case 1:
            index = 0;
            break;
          case 2:
            index = 1;
            break;
          case 4:
            index = 2;
            break;
          case 8:
            index = 3;
            break;
          case 16:
            index = 4;
            break;
          case 32:
            index = 5;
            break;
        }
        this.picDetails.type = type[index];
        // 时间
        this.picDetails.time = moment(data.time).format('YYYY-MM-DD HH:mm:ss')
        
      },
      // 关闭大图
      closePic() {
        this.isShowPic = false;
        this.$refs.img.src = '';
        this.$refs.img.style.left = '0';
        this.$refs.img.style.top = '0';
      },
      selected(index) {
        this.moreImageArr[index].select = this.moreImageArr[index].select ? false : true;
        
        this.$forceUpdate();
      },
      selectedM(index){
        if (this.moreResultArr[index].select){
          if (this.moreResultArr[index].select === true){
            this.$set(this.moreResultArr[index], 'select',   false)
            for (let i = 0;i<this.selectItemsId.length;i++){
              let res = this.selectItemsId[i]
               if (res === this.moreResultArr[index].id){
                 this.selectItemsId.splice(i,1)
               }
            }
          } else if (this.moreResultArr[index].select === false){
            this.$set(this.moreResultArr[index], 'select',  true)
            this.selectItemsId.push(this.moreResultArr[index].id)
          }
          
        } else {
          this.$set(this.moreResultArr[index], 'select', true)
          this.selectItemsId.push(this.moreResultArr[index].id)
        }
      },
      mainSuggesion(mainSuggesionString, cb) {
        let results = this.mainDoctorList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      viceSuggesion(viceSuggesionString, cb) {
        let results = this.viceDoctorList;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      filterDisease(queryString) {
        return restaurant => {
          return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
          );
        };
      },
      queryDisease(queryString, cb) {
        const restaurants = this.allDisease;
        const results = queryString ? restaurants.filter(this.filterDisease(queryString)) : restaurants;
        const arr = [];
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (!data[i].children && data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
              if (data[i].name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
                arr.push({
                  id: data[i].id,
                  value: data[i].name,
                })
              }
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (template.myTemplate) {
          f(template.myTemplate);
        }
        for (const item of results) {
          const findIndex = arr.findIndex(item1 => item.value === item1.value);
          if (findIndex === -1) {
            arr.push(item);
          }
        }
        cb(arr);
      },
      selectedDisease(item) {
        this.isTrigger = true;
        // this.selectedDiagnose = true;
        // this.inHospitalData.diagnosis = item.value;
        this.diagnosisId = item.id;
      },
      // 限制只输入数字
      stipulateNumber(value) {
        this.diagnoseForm[value] = this.diagnoseForm[value].replace(/[^\d]/g, '');
      },
      // 限制年龄只输入数字
      ageChange(value) {
        this[value] = this[value].replace(/[^\d]/g, '');
      },
      // 循环遍历取得筛选条件
      forInDiagnoseForm(diagnose) {
        let newDiagnoseForm = '';
        for (let key in diagnose) {
          // console.log(key, diagnose[key]);
          if (diagnose.hasOwnProperty(key)) {
            
            // 判断要穿数字还是字符串
            const bool = (key === 'image_type_flag') || (key === 'age_start') || (key === 'age_end') || (key === 'tagged');
            let val = diagnose[key];
            if (val !== '') {
              if (bool) {
                newDiagnoseForm += `${key}:${val},`;
              } else {
                newDiagnoseForm += `${key}:"${val.replace(/\\/g, '\\\\\\\\').replace(/"/g, '\\"')}",`;
              }
            }
          }
        }
        return newDiagnoseForm;
      },
      
      // 获取图片大小
      imgLoad(e) {
        this.picDetails.size = e.target.width + ' x ' + e.target.height;
      },
      // 图片拖拽
      imgMoseDown(e) {
        let tag = e.srcElement;
        const left = Number(tag.style.left.split('px')[0]);
        const top = Number(tag.style.top.split('px')[0]);
        this.imgSwitch = true;
        let clientX = e.clientX;
        let clientY = e.clientY;
        let count = 0;
        document.onmouseup = () => {
          this.imgSwitch = false;
        };
        document.onmousemove = (e) => {
          count++;
          if (this.imgSwitch) {
            if (count % 2 === 0) {
              const eX = e.clientX;
              const eY = e.clientY;
              const changeX = eX - clientX;
              const changeY = eY - clientY;
              tag.style.left = (left + changeX) + 'px';
              tag.style.top = (top + changeY) + 'px';
            }
          }
        };
      },
    },
    components: {
      DiagnoseRecord,
      PatientDiagnoseRecord,
      Lookimage
    },
    beforeCreate() {
      that = this;
    },
    filters: {
      filtersMoment(time) {
        return (moment(time).format('YYYY-MM-DD HH:mm:ss'));
      },
      filtersConclusion(id) {
        if (id !== '') {
          let name;
          // 从自定义模板中找病种名称
          const f = (data) => {
            for (let i = 0; i < data.length; i++) {
              if (data[i].id === id) {
                name = data[i].name;
                break;
              } else if (data[i].children && data[i].children.length) {
                f(data[i].children);
              }
            }
          };
          if (template.myTemplate) {
            f(template.myTemplate);
          }
          // 如果自定义中没有找到则在原始模板中查找
          if (!name) {
            if (that.knowledgeDic[id]) {
              name = that.knowledgeDic[id].name
            }
          }
          return name ? name : id;
        }
      },
      filtersType(index) {
        const obj = {
          0: '',
          1: '大体图/伍德灯',
          2: '浸润皮肤镜图',
          4: '偏振光皮肤镜图',
          8: '皮肤CT',
          16: '皮肤B超',
          32: '皮肤病理',
        };
        return obj[index];
      },
    },
  };
</script>


<style>
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 112px;
  }
</style>
